/* ============================================================
 * ck-track-order.js — Track My Order controller (V2 Experimental)
 * ------------------------------------------------------------
 * Framework-free replacement for the legacy Vue order-status app.
 * No Vue, no Globo, no jQuery. Plain ES5-safe DOM + fetch.
 *
 * Talks to the SAME Shopify app-proxy endpoints as production:
 *   GET {base}/ordersbyzip_lastname?LastName=&zip=
 *   GET {base}/ordersbyordernoandserialno?OrderNo=&serialNo=
 *
 * Response shape (verified live):
 *   { Error_Message, Error_Code, Orders: [ {
 *       Order_no, Name, City, Zip, Order_date, Cancelled,
 *       Parts: [ { Serial_No, Description, Material_Description, Model,
 *                  Shipping_agent_used, Status, Shipment_date,
 *                  Package_No, Package_link, Order_No, Order_date } ]
 *   } ] }
 *
 * Behaviour:
 *  - Last name + zip lookup.
 *  - Distributor serial + order number lookup.
 *  - When >= 2 orders match a last-name search, list every matching
 *    order and let the customer pick the one to view (replaces the old
 *    first-name + order-date disambiguation flow).
 *  - "Track another order" resets the lookup in place (no navigation).
 *  - Dates formatted as "MMM D, YYYY" in UTC (matches old moment .utc()).
 *  - All order data rendered via textContent (XSS-safe).
 * ============================================================ */
(function () {
  'use strict';

  
  function init(root) {
  if (root.hasAttribute('data-ck-init')) return;
  root.setAttribute('data-ck-init', '');

  var CFG = window.CK_TRACK_CONFIG || {};
  var BASE = (CFG.proxyBase || '/apps/coverking-api/orderstatus/api/Shop').replace(/\/$/, '');

  var statusEl = root.querySelector('[data-ck-status]');
  var resultsEl = root.querySelector('[data-ck-results]');
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-ck-tab]'));
  var panels = {
    customer: root.querySelector('#ck-panel-customer'),
    distributor: root.querySelector('#ck-panel-distributor')
  };

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  

  function formatDate(value) {
    if (!value) return '';
    var d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear();
  }

  
  function safeHttpUrl(value) {
    if (!value) return '';
    var s = String(value);
    try {
      var u = new URL(s, window.location.origin);
      return (u.protocol === 'http:' || u.protocol === 'https:') ? s : '';
    } catch (e) {
      return '';
    }
  }

  function el(tag, opts) {
    var node = document.createElement(tag);
    opts = opts || {};
    if (opts.className) node.className = opts.className;
    if (opts.text != null) node.textContent = opts.text; // XSS-safe
    if (opts.attrs) {
      for (var k in opts.attrs) {
        if (Object.prototype.hasOwnProperty.call(opts.attrs, k)) node.setAttribute(k, opts.attrs[k]);
      }
    }
    return node;
  }

  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }

  // Static markup only — never interpolates data (XSS-safe).
  var ALERT_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10.3 3.9 1.8 18.1a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>';

  function alertIcon(title) {
    var s = el('span', { className: 'ck-track__alert', attrs: { 'aria-hidden': 'true' } });
    if (title) s.setAttribute('title', title);
    s.innerHTML = ALERT_SVG;
    return s;
  }

  function showStatus(message, kind) {
    statusEl.hidden = false;
    statusEl.className = 'ck-track__status ck-track__status--' + (kind || 'info');
    statusEl.textContent = message;
  }
  function hideStatus() { statusEl.hidden = true; clear(statusEl); }

  function setLoading(form, isLoading) {
    var submit = form.querySelector('.ck-track__submit');
    var label = form.querySelector('.ck-track__submit-label');
    var spinner = form.querySelector('.ck-track__spinner');
    if (!submit) return;
    submit.disabled = isLoading;
    if (spinner) spinner.hidden = !isLoading;
    if (label) label.style.opacity = isLoading ? '0.6' : '1';
  }

  function fieldError(form, message) {
    var err = form.querySelector('[data-ck-error]');
    if (!err) return;
    if (message) { err.hidden = false; err.textContent = message; }
    else { err.hidden = true; err.textContent = ''; }
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Request failed (' + r.status + ')');
        return r.json();
      });
  }

  
  function backendError(d) {
    return d && (
      (d.Error_Message && String(d.Error_Message).trim()) ||
      (d.Error_Code && String(d.Error_Code) !== '0')
    );
  }

  

  function activateTab(name) {
    tabs.forEach(function (t) {
      var on = t.getAttribute('data-ck-tab') === name;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Object.keys(panels).forEach(function (key) {
      var p = panels[key];
      if (!p) return;
      var on = key === name;
      p.hidden = !on;
      p.classList.toggle('is-hidden', !on);
    });
    hideStatus();
    resultsEl.hidden = true;
    clear(resultsEl);
  }

  tabs.forEach(function (t) {
    t.addEventListener('click', function () { activateTab(t.getAttribute('data-ck-tab')); });
  });

  

  function resetLookup() {
    hideStatus();
    resultsEl.hidden = true;
    clear(resultsEl);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function renderOrdersTable(orders) {
    clear(resultsEl);
    resultsEl.hidden = false;

    var heading = el('h2', { className: 'ck-track__results-title', text: 'My orders' });
    resultsEl.appendChild(heading);

    var hasTracking = false;

    orders.forEach(function (order) {
      var card = el('div', { className: 'ck-track__order' });

      var head = el('div', { className: 'ck-track__order-head' });
      var left = el('div', { className: 'ck-track__order-meta' });

      var orderLine = el('div');
      orderLine.appendChild(el('strong', { text: 'Order No: ' }));
      orderLine.appendChild(el('span', { text: order.Order_no || '' }));
      if (String(order.Cancelled).toLowerCase() === 'true') {
        orderLine.appendChild(el('span', { className: 'ck-track__cancelled', text: ' (Cancelled)' }));
      }
      left.appendChild(orderLine);

      var nameLine = el('div');
      nameLine.appendChild(el('strong', { text: 'Name: ' }));
      nameLine.appendChild(el('span', { text: order.Name || '' }));
      left.appendChild(nameLine);

      var addrLine = el('div');
      addrLine.appendChild(el('strong', { text: 'Address: ' }));
      addrLine.appendChild(el('span', { text: [order.City, order.Zip].filter(Boolean).join(' ') }));
      left.appendChild(addrLine);

      var right = el('div', { className: 'ck-track__order-date' });
      right.appendChild(el('strong', { text: 'Order Date: ' }));
      right.appendChild(el('span', { text: formatDate(order.Order_date) }));

      head.appendChild(left);
      head.appendChild(right);
      card.appendChild(head);

      var parts = order.Parts;
      if (parts && parts.length) {
        var wrap = el('div', { className: 'ck-track__table-wrap' });
        var table = el('table', { className: 'ck-track__table' });
        var thead = el('thead');
        var hrow = el('tr');
        ['Serial No', 'Description', 'Material', 'Vehicle', 'Carrier', 'Status', 'Shipped', 'Tracking #']
          .forEach(function (h) { hrow.appendChild(el('th', { text: h })); });
        thead.appendChild(hrow);
        table.appendChild(thead);

        var tbody = el('tbody');
        parts.forEach(function (part) {
          if (part.Order_No != null && order.Order_no != null && part.Order_No !== order.Order_no) return;
          var row = el('tr');
          row.appendChild(el('td', { text: part.Serial_No || '' }));
          row.appendChild(el('td', { text: part.Description || '' }));
          row.appendChild(el('td', { text: part.Material_Description || '' }));
          row.appendChild(el('td', { text: part.Model || '' }));
          row.appendChild(el('td', { text: part.Shipping_agent_used || '' }));
          row.appendChild(el('td', { text: part.Status || '' }));
          row.appendChild(el('td', { text: formatDate(part.Shipment_date) }));

          var trackTd = el('td');
          if (part.Package_No) {
            hasTracking = true;
            var trackHref = safeHttpUrl(part.Package_link);
            if (trackHref) {
              var a = el('a', {
                className: 'ck-track__tracking-link',
                text: part.Package_No,
                attrs: { href: trackHref, target: '_blank', rel: 'noopener noreferrer' }
              });
              trackTd.appendChild(a);
            } else {
              trackTd.appendChild(el('span', { text: part.Package_No }));
            }
            trackTd.appendChild(alertIcon('Tracking can take up to 2 business days to show activity.'));
          }
          row.appendChild(trackTd);
          tbody.appendChild(row);
        });
        table.appendChild(tbody);
        wrap.appendChild(table);
        card.appendChild(wrap);
      }

      resultsEl.appendChild(card);
    });

    if (hasTracking) {
      var note = el('p', { className: 'ck-track__tracking-note' });
      note.appendChild(alertIcon());
      note.appendChild(el('span', {
        text: 'A tracking number can take up to 2 business days to show activity while the carrier picks up and scans the package.'
      }));
      resultsEl.appendChild(note);
    }

    var another = el('button', {
      className: 'ck-track__another underline',
      text: 'Track another order',
      attrs: { type: 'button' }
    });
    another.addEventListener('click', resetLookup);
    resultsEl.appendChild(another);
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  

  function renderOrderPicker(orders) {
    clear(resultsEl);
    resultsEl.hidden = false;

    showStatus('We found ' + orders.length + ' orders. Select the one you want to check.', 'info');

    var list = el('div', { className: 'ck-track__picker' });

    orders.forEach(function (order) {
      var item = el('button', { className: 'ck-track__picker-item', attrs: { type: 'button' } });

      var meta = el('div', { className: 'ck-track__picker-meta' });

      var line = el('div', { className: 'ck-track__picker-order' });
      line.appendChild(el('strong', { text: 'Order ' + (order.Order_no || '') }));
      line.appendChild(el('span', { className: 'ck-track__picker-date', text: ' — ' + formatDate(order.Order_date) }));
      meta.appendChild(line);

      var items = (order.Parts || [])
        .map(function (p) { return p.Description || ''; })
        .filter(Boolean)
        .join(', ');
      if (items) meta.appendChild(el('div', { className: 'ck-track__picker-items', text: items }));

      item.appendChild(meta);

      var cancelled = String(order.Cancelled).toLowerCase() === 'true';
      var statuses = [];
      (order.Parts || []).forEach(function (p) {
        if (p.Status && statuses.indexOf(p.Status) === -1) statuses.push(p.Status);
      });
      var statusText = cancelled ? 'Cancelled' : (statuses.join(' / ') || 'View status');
      item.appendChild(el('span', {
        className: 'ck-track__picker-status' + (cancelled ? ' ck-track__cancelled' : ''),
        text: statusText
      }));

      item.addEventListener('click', function () {
        hideStatus();
        renderOrdersTable([order]);
        var back = el('button', { className: 'ck-track__back', text: '← Back to all orders', attrs: { type: 'button' } });
        back.addEventListener('click', function () { renderOrderPicker(orders); });
        resultsEl.insertBefore(back, resultsEl.firstChild);
      });

      list.appendChild(item);
    });

    resultsEl.appendChild(list);
    resultsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  

  function handleLastNameLookup(form) {
    var lastName = (form.querySelector('[data-ck-input="lastName"]').value || '').trim();
    var zip = (form.querySelector('[data-ck-input="zip"]').value || '').trim();
    fieldError(form, '');
    if (!lastName || !zip) { fieldError(form, 'Please enter both last name and zip code.'); return; }

    hideStatus();
    resultsEl.hidden = true; clear(resultsEl);
    setLoading(form, true);

    var url = BASE + '/ordersbyzip_lastname?LastName=' + encodeURIComponent(lastName) + '&zip=' + encodeURIComponent(zip);
    getJSON(url)
      .then(function (data) {
        if (backendError(data)) throw new Error('backend soft error'); 
        var orders = (data && data.Orders) || [];
        if (orders.length === 0) {
          showStatus('No orders were found for the provided last name and zip code.', 'info');
        } else if (orders.length >= 2) {
          renderOrderPicker(orders);
        } else {
          renderOrdersTable(orders);
        }
      })
      .catch(function () {
        showStatus('Sorry, we could not reach order status right now. Please try again shortly.', 'error');
      })
      .then(function () { setLoading(form, false); });
  }

  function handleDistributorLookup(form) {
    var serialNo = (form.querySelector('[data-ck-input="serialNo"]').value || '').trim();
    var orderNo = (form.querySelector('[data-ck-input="orderNo"]').value || '').trim();
    fieldError(form, '');
    if (!serialNo || !orderNo) { fieldError(form, 'Please enter both serial number and order number.'); return; }

    hideStatus();
    resultsEl.hidden = true; clear(resultsEl);
    setLoading(form, true);

    var url = BASE + '/ordersbyordernoandserialno?OrderNo=' + encodeURIComponent(orderNo) + '&serialNo=' + encodeURIComponent(serialNo);
    getJSON(url)
      .then(function (data) {
        if (backendError(data)) throw new Error('backend soft error'); 
        var orders = (data && data.Orders) || [];
        if (orders.length === 0) {
          showStatus('No order found for that serial and order number.', 'info');
        } else {
          renderOrdersTable(orders);
        }
      })
      .catch(function () {
        showStatus('Sorry, we could not reach order status right now. Please try again shortly.', 'error');
      })
      .then(function () { setLoading(form, false); });
  }

  

  Object.keys(panels).forEach(function (key) {
    var form = panels[key];
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mode = form.getAttribute('data-ck-lookup');
      if (mode === 'lastname') handleLastNameLookup(form);
      else if (mode === 'distributor') handleDistributorLookup(form);
    });
  });
  }

  function boot() {
    document.querySelectorAll('.ck-track').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target && e.target.querySelector ? e.target.querySelector('.ck-track') : null;
    if (sec) init(sec);
  });
})();
